import React, { useState } from 'react';
import Contact from '../assets/contact-azf.png';

const ContactSection = () => {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = () => {
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 5000);
  };

  return (
    <section className="contact-section" id="contact">
      <div className="contact-left">
        <div className="contact-image-wrap">
          <img src={Contact} alt="Contact" className="contact-image" />
          <div className="contact-info-box">
            <h2>Get In Touch</h2>
            <p>Have questions about our grants or application process? We're here to help.</p>
            <div className="contact-email">
              <span role="img" aria-label="email">📧</span>{' '}
              <a
                href="mailto:abdullahzamanfoundation@gmail.com"
                style={{ color: 'inherit', textDecoration: 'none', cursor: 'pointer' }}
              >
                abdullahzamanfoundation@gmail.com
              </a>
            </div>
          </div>
        </div>
      </div>
      <form
        className="contact-form"
        action="https://script.google.com/macros/s/AKfycbyBmlz06f0Lltq1YdBg6qiQ2ZEayH9CqHiTsPxgaFbNOVZZSubLki7bgDYJcLHp8aRrKA/exec"
        method="POST"
        target="hidden-iframe"
        onSubmit={handleSubmit}
        style={{ position: "relative" }}
      >
        <input type="text" name="name" placeholder="Your Name" required />
        <input type="email" name="email" placeholder="Email" required />
        <input type="text" name="subject" placeholder="Subject" />
        <textarea name="message" placeholder="Write a Message…" rows={4} required></textarea>
        <button type="submit" className="contact-btn">Send Message</button>
        {submitted && (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: '-36px',
            justifyContent: 'center',
            gap: '6px',
            color: '#159c4d',
            fontFamily: 'League Spartan, sans-serif',
            fontWeight: 600,
            fontSize: '18px',
          }}>
            <svg viewBox="0 0 20 20" width="20" height="20" style={{marginRight: 2}}>
              <circle cx="10" cy="10" r="10" fill="#16a34a" />
              <path d="M6 11l2 2 5-5" stroke="#fff" strokeWidth="2" fill="none"/>
            </svg>
            Submitted. We'll reply soon.
          </div>
        )}
      </form>
      <iframe name="hidden-iframe" style={{ display: "none" }}></iframe>
    </section>
  );
};

export default ContactSection;
